export default __webpack_public_path__ + "static/media/icon-overcast.7d41179c.svg";